import { createSelector } from '@reduxjs/toolkit';
import { getOrganization } from './getOrganization';

// Aktivitetskoder som identifiserer legevirksomhet (Legetjeneste 86.21* og
// Spesialisert legetjeneste 86.22*). Brukes til å avgjøre hvilke
// skjermforslag som er relevante for organisasjonen: leger får alt, øvrige
// grupper får alt unntatt det som er rent lege-spesifikt.
//
// Merk: `maritimeDoctor`-selektoren ser etter den eksakte koden 86.21.01
// (sjøfartslegetjeneste). Denne selektoren bruker bevisst prefiks-matching
// for å fange opp hele legetjeneste-spennet, ikke en enkelt underkode.
const DOCTOR_ACTIVITY_CODE_PREFIXES = ['86.21', '86.22'];

// Ren hjelpefunksjon slik at logikken kan enhetstestes uten å bygge en full
// Redux-state.
export function isDoctorByActivityCodes(activityCodes: readonly string[]): boolean {
  return activityCodes.some((code) => DOCTOR_ACTIVITY_CODE_PREFIXES.some((prefix) => code.startsWith(prefix)));
}

export const isDoctorOrganization = createSelector(getOrganization, function (organization): boolean {
  if (organization === undefined) return false;
  return isDoctorByActivityCodes(organization.activityCodes);
});
